export const calculateItemPrice = (item) => {
    let price = 0;
    let itemPrice = 0;
    item.modifiers && item.modifiers.map(modifier => modifier.rawItems.map(rI => {
        itemPrice += rI?.price ? parseFloat(rI.price) : 0;
    }));
    price += itemPrice;
    return price;
}